<template>
  <div class="home-contract-tx-detail">
    <normal-table
      :table-data="tableData"
      :table-col="tableCol"
      :paging="paging"
      :show-edit="showEdit"
      :operator="operator"
      :operate-col="operatorCol"
      @pagination="getTxnListFn"
    ></normal-table>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'TxnInfo',
  data() {
    return {
      showEdit: true,
      tableCol: [
        {
          label: '交易id',
          prop: 'txId',
          minWidth: 297
          // path: row => {
          //   return {
          //     name: 'txnDetail',
          //     query: {
          //       txId: row.txId
          //     }
          //   }
          // },
        },
        {
          label: '区块高度',
          prop: 'blockHeight',
          minWidth: 116
        },
        {
          label: '发起组织',
          prop: 'orgId',
          minWidth: 116
        },
        {
          label: '目标合约',
          prop: 'contractName',
          minWidth: 116
        },
        {
          label: '上链时间',
          prop: 'createAt',
          minWidth: 116
        },
        {
          label: '发起用户',
          prop: 'sender',
          minWidth: 132
        },
        {
          label: '交易状态',
          prop: 'txStatusCode',
          minWidth: 202
        }
      ],
      operator: [
        {
          text: '查看',
          showText: true,
          icon: 'icon-check',
          class: 'operate-check',
          click: row => {
            return this.goDetail(row)
          }
        }
      ],
      operatorCol: {
        minWidth: 74
      }
    }
  },
  computed: {
    ...mapState({
      tableData: state => state.home.txn_list,
      paging: state => state.home.txn_paging
    })
  },
  mounted() {
    this.getTxnListFn()
  },
  methods: {
    ...mapActions(['getTxnLists']),
    getTxnListFn(params = {}) {
      params.offset = params.offset * this.paging.limit || 0
      params.limit = params.limit || 10
      params.chainId = this.$store.state.home.chainCid
      params.contractName = this.$route.query.contractName || ''
      this.getTxnLists(params)
    },
    goDetail(row) {
      this.$router.push({
        name: 'txnDetail',
        query: { ...row }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'home-contract-tx-detail',
  (
    --home-contract-detail-operate-check-color: #45c2ff
  ),
  (
    --home-contract-detail-operate-check-color: #45c2ff
  )
);

.home-contract-tx-detail {
  @include adaptation(
    (
      --home-contract-detail-tx-list-item-height: 62px
    )
  );
  .normal-table-wrap {
    /deep/ {
      .normal-table {
        .el-table__body {
          tr {
            height: var(--home-contract-detail-tx-list-item-height);
          }
        }

        .el-table__cell {
          .cell {
            height: auto;
            white-space: normal;

            .operate-item {
              &.operate-check {
                color: var(--home-contract-detail-operate-check-color);
              }
            }
          }
        }
      }
    }
  }
}
</style>
